var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dropbox",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.699,
    height: 65.699,
    viewBox: "0 0 65.699 65.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M32.85,0A32.849,32.849,0,1,0,65.7,32.849,32.848,32.848,0,0,0,32.85,0Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M35.416,37.934,39.1,35.723v2.012L26.674,45.8,14.52,37.677v-1.9l3.636,2.154.4.238.374-.285,7.851-6.026,7.849,6.026.376.285.407-.24ZM26.811,15.2l11.953,6.868L26.7,30.056,14.715,22.505l12.1-7.307Zm20.757.4L35.254,7.729l-8.467,7.1-8.276-7.1L5.837,15.984l8.726,6.638L5.837,29.26,14.52,34.4l3.991,2.361,8.276-6.35,8.274,6.35,4.045-2.427L47.57,29.26l-8.081-6.929L47.568,15.6Z",
    transform: "translate(6.147 8.139)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.0621532760a2e275fbac28de1075587b.svg";
export { ForwardRef as ReactComponent };